import React from 'react';
import { ImageProps } from '.';

const SvgPartnerCenterSymbolWhNew = ({ size = 30, ...props }: ImageProps): JSX.Element => {
  return (
    <svg width={size} height={(size && Math.floor(size / 1)) || 30} fill='none' viewBox='0 0 30 30' {...props}>
      <path
        fill='#fff'
        d='M19.176 6.564a.933.933 0 0 1 .655-.264c.247 0 .48.094.654.264l6.66 6.49c.551.537.855 1.252.855 2.012v8.567h-6.77v-6.5c0-.279-.111-.54-.313-.738l-5.915-5.764 4.174-4.067Z'
      />
      <path
        fill='#FFCD00'
        d='m2.856 13.053 6.659-6.49a.945.945 0 0 1 1.31 0l4.174 4.068-5.915 5.764a1.022 1.022 0 0 0-.314.737v6.502H2v-8.567c0-.76.304-1.476.856-2.014Z'
      />
    </svg>
  );
};

export default SvgPartnerCenterSymbolWhNew;
